import React, { useEffect, useRef, useState, forwardRef, useCallback  } from 'react';
import { Column, Pager, Paging } from 'devextreme-react/data-grid';
import { ScrollView, DataGrid, DateBox } from 'devextreme-react';
import { Popup } from 'devextreme-react/popup';
import { Button } from 'devextreme-react/button';
import { ExcelExport } from '../../common/excel';
import moment from 'moment';
import { FormatLineNumber, FormatNumber } from '../../common';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ko } from 'date-fns/esm/locale';
import SelectDatePicker from "@netojose/react-select-datepicker";

const CorpListUseInfoPopup = ({
  onValueChanged,
  onHiding,
  onClickSearch,
  useInfo,
  useInfoList,
  visibleUseInfoPopup,
  onChange,
  dateString,
  onDateChange,
  onDateChangeEnd,
}) => {
  // console.log('CorpListUseInfoPopup Load');

  const refDataGid = useRef();
  
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  
  const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
    <button className="example-custom-input" onClick={onClick} ref={ref}>
      {value}
    </button>
  ));

  //const [startdate, setDate] = useState(new Date());
  
  useEffect(() => {
    // console.log('CorpListUseInfoPopup > useEffect()');
    refDataGid.current.instance.refresh();
  }, [useInfo, dateString]);

  
  return (
    <React.Fragment>
      <Popup
        title="법인콜 이용 상세내역"
        className="popup"
        height="90vh"
        visible={visibleUseInfoPopup}
        onHiding={onHiding}
      >
        <ScrollView>
          <div className="corp-list-use-info-top">
            <div className="corp-list-use-info-top-label">시작일자 : </div>
            <div className="corp-list-use-info-top-value">
              {/* <DateBox
                type="date"
                value={useInfo.FromDate}
                width={100}
                displayFormat="yyyy-MM-dd"
                onValueChanged={(e) => onValueChanged('FromDate', e)}
                openOnFieldClick={true}
                acceptCustomValue={false}
              /> */}
              {/* <DatePicker 
                selected={startDate} 
                onChange={(date) => {
                  onChange('startDate', date)
                  setStartDate(date)
                }} 
                locale={ko}
                dateFormat="yyyy-MM-dd"
                customInput={<ExampleCustomInput />}
              /> */}
              <SelectDatePicker
                  format="year/month/day"
                  yearLabel=""
                  monthLabel=""
                  dayLabel=""
                  value={startDate}
                  showErrors="false"
                  onDateChange={onDateChange}
                  className="date-picker"
                  monthNames={[
                    "1월",
                    "2월",
                    "3월",
                    "4월",
                    "5월",
                    "6월",
                    "7월",
                    "8월",
                    "9월",
                    "10월",
                    "11월",
                    "12월"
                  ]}
                />
            </div>
            <div className="corp-list-use-info-top-label">종료일자 : </div>
            <div className="corp-list-use-info-top-value">
              {/* <DateBox
                type="date"
                value={useInfo.ToDate}
                width={100}
                displayFormat="yyyy-MM-dd"
                onValueChanged={(e) => onValueChanged('ToDate', e)}
                openOnFieldClick={true}
                acceptCustomValue={false}
              /> */}
              {/* <DatePicker 
                selected={endDate} 
                onChange={(date) => {
                  onChange('endDate', date)
                  setEndDate(date)
                }} 
                locale={ko}
                dateFormat="yyyy-MM-dd"
                minDate={startDate}
                customInput={<ExampleCustomInput />}
              /> */}
              <SelectDatePicker
                  format="year/month/day"
                  yearLabel=""
                  monthLabel=""
                  dayLabel=""
                  value={endDate}
                  maxDate={startDate}
                  showErrors="false"
                  onDateChange={onDateChangeEnd}
                  className="date-picker"
                  monthNames={[
                    "1월",
                    "2월",
                    "3월",
                    "4월",
                    "5월",
                    "6월",
                    "7월",
                    "8월",
                    "9월",
                    "10월",
                    "11월",
                    "12월"
                  ]}
                />
            </div>
            <Button
              className="normal-button"
              stylingMode="contained"
              type="normal"
              text="조회"
              onClick={onClickSearch}
            />
          </div>
          <div className="corp-list-use-info-content popup-content">
            <DataGrid
              className={'dx-card wide-card'}
              dataSource={useInfoList}
              showBorders={true}
              focusedRowEnabled={true}
              defaultFocusedRowIndex={0}
              columnAutoWidth={true}
              keyExpr="RequestDateTime"
              width="100%"
              height="100%"
              ref={refDataGid}
            >
              <Column
                dataField="AppDate"
                caption="접수일자"
                alignment="center"
                customizeText={(cellData) =>
                  moment(cellData.value, 'YYYYMMDD').format('YYYY-MM-DD')
                }
              />
              <Column
                dataField="wDateTime"
                caption="접수일시"
                alignment="center"
                customizeText={(cellData) =>
                  moment(cellData.value).utc().format('YY-MM-DD HH:mm:ss')
                }
              />
              <Column
                dataField="CustomerName"
                caption="이용자명"
                alignment="center"
              />
              <Column
                dataField="CallerLineNumber"
                caption="이용자번호"
                alignment="center"
                customizeText={(e) => FormatLineNumber(e.value)}
              />
              <Column
                dataField="CallbackLineNumber"
                caption="콜백번호"
                alignment="center"
                customizeText={(e) => FormatLineNumber(e.value)}
              />
              <Column
                dataField="StartDong"
                caption="출발지"
                alignment="center"
                // width="10vw"
                cellRender={(cellData) => (
                  <div>
                    {cellData.value}
                    <br />
                    {cellData.data['StartPOI']}
                  </div>
                )}
              />
              <Column
                dataField="StartPOI"
                caption="출발지"
                alignment="center"
                visible={false}
              />
              <Column
                dataField="PassThrough"
                caption="경유지"
                alignment="center"
              />
              <Column
                dataField="EndDong"
                caption="도착지"
                alignment="center"
                width="25vw"
                cellRender={(cellData) => (
                  <>
                    {cellData.value}
                    <br />
                    {cellData.data['EndPOI']}
                  </>
                )}
              />
              <Column
                dataField="EndPOI"
                caption="도착지"
                alignment="center"
                visible={false}
              />
              <Column
                dataField="DriverName"
                caption="대리기사"
                alignment="center"
              />
              <Column
                dataField="Charge"
                caption="이용금액"
                alignment="center"
                customizeText={(cellData) =>
                  FormatNumber(parseInt(cellData.value))
                }
              />
              <Column
                dataField="AllocationDateTime"
                caption="배차시간"
                alignment="center"
                customizeText={(cellData) =>
                  moment(cellData.value, 'YYYYMMDDHHmmss').format(
                    'YY-MM-DD HH:mm:ss'
                  )
                }
              />
              <Column
                dataField="TakeOffDateTime"
                caption="운행시간"
                alignment="center"
                customizeText={(cellData) =>
                  moment(cellData.value, 'YYYYMMDDHHmmss').format(
                    'YY-MM-DD HH:mm:ss'
                  )
                }
              />
              <Column
                dataField="CompleteDateTime"
                caption="종료시간"
                alignment="center"
                customizeText={(cellData) =>
                  moment(cellData.value, 'YYYYMMDDHHmmss').format(
                    'YY-MM-DD HH:mm:ss'
                  )
                }
              />
              <Column
                dataField="CustomerPart"
                caption="부서"
                alignment="center"
              />
              <Column
                dataField="CustomerDuty"
                caption="직책"
                alignment="center"
              />
              <Column dataField="Note" caption="메모" alignment="center" />
              <Paging defaultPageSize={10} />
              <Pager showPageSizeSelector={true} showInfo={true} disp />
            </DataGrid>
          </div>
          <div className="corp-list-use-info-bottom">
            <Button
              stylingMode="contained"
              type="success"
              text="Excel"
              onClick={() =>
                ExcelExport(
                  refDataGid.current.instance,
                  `법인고객_이용내역_${moment().format('YYYY-MM-DD')}.xlsx`
                )
              }
            />
            <Button
              stylingMode="contained"
              type="normal"
              text="닫기"
              onClick={onHiding}
            />
          </div>
        </ScrollView>
      </Popup>
    </React.Fragment>
  );
};

export default React.memo(CorpListUseInfoPopup);
